module.exports = __webpack_public_path__ + "static/media/verified.3f9037ee.svg";